import { useRef } from "react";
import { ReplayIcon, SoundIcon } from "./Icons";
import { useDialogFocusTrap } from "./useDialogFocusTrap";

interface PauseModalProps {
  muted: boolean;
  reducedMotion: boolean;
  onResume: () => void;
  onRestart: () => void;
  onExit: () => void;
  onToggleMute: () => void;
  onToggleReducedMotion: () => void;
}

export function PauseModal(props: PauseModalProps) {
  const panelRef = useRef<HTMLElement>(null);
  const resumeRef = useRef<HTMLButtonElement>(null);
  useDialogFocusTrap(panelRef, resumeRef);
  return (
    <div className="modal-layer" role="dialog" aria-modal="true" aria-labelledby="pause-title">
      <section ref={panelRef} className="storybook-panel pause-panel">
        <h2 id="pause-title">המשחק מושהה</h2>
        <button ref={resumeRef} className="primary-button" onClick={props.onResume}>חזרה למשחק</button>
        <div className="settings-row">
          <button className="secondary-button" onClick={props.onToggleMute}><SoundIcon muted={props.muted} />{props.muted ? "הפעלת צלילים" : "השתקת צלילים"}</button>
          <button className={`secondary-button ${props.reducedMotion ? "active" : ""}`} onClick={props.onToggleReducedMotion}>הפחתת תנועה</button>
        </div>
        <div className="settings-row quiet">
          <button className="text-button" onClick={props.onRestart}><ReplayIcon />התחלה מחדש</button>
          <button className="text-button" onClick={props.onExit}>בחירת דמות</button>
        </div>
      </section>
    </div>
  );
}
